"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subjects = void 0;
var mathSubjectInfo = {
    subjectName: "Mathematics",
    subjectBid: "1",
};
var languageArtsSubjectInfo = {
    subjectName: "Language Arts",
    subjectBid: "2",
};
var scienceSubjectInfo = {
    subjectName: "Science",
    subjectBid: "4",
};
/**
 * A list of all available subjects and courses
 */
exports.subjects = [
    {
        name: mathSubjectInfo.subjectName,
        sortOrder: 1,
        subjectBid: mathSubjectInfo.subjectBid,
        courses: [
            __assign({ name: "Math K-12", sortOrder: 1, fullDisplayName: "Math K-12", measurementScaleID: "1", apiKey: "mathematics" }, mathSubjectInfo),
            __assign({ name: "Algebra 1", sortOrder: 2, fullDisplayName: "Math: Algebra 1", measurementScaleID: "100", apiKey: "algebra-1" }, mathSubjectInfo),
            __assign({ name: "Algebra 2", sortOrder: 3, fullDisplayName: "Math: Algebra 2", measurementScaleID: "101", apiKey: "algebra-2" }, mathSubjectInfo),
            __assign({ name: "Geometry", sortOrder: 4, fullDisplayName: "Math: Geometry", measurementScaleID: "102", apiKey: "geometry" }, mathSubjectInfo),
            __assign({ name: "Integrated Math 1", sortOrder: 5, fullDisplayName: "Math: Integrated Math 1", measurementScaleID: "103", apiKey: "integrated-math-1" }, mathSubjectInfo),
            __assign({ name: "Integrated Math 1 and 2", sortOrder: 6, fullDisplayName: "Math: Integrated Math 1 and 2", measurementScaleID: "104", apiKey: "integrated-math-1-and-2" }, mathSubjectInfo),
            __assign({ name: "Integrated Math 2", sortOrder: 7, fullDisplayName: "Math: Integrated Math 2", measurementScaleID: "105", apiKey: "integrated-math-2" }, mathSubjectInfo),
            __assign({ name: "Integrated Math 3", sortOrder: 8, fullDisplayName: "Math: Integrated Math 3", measurementScaleID: "106", apiKey: "integrated-math-3" }, mathSubjectInfo),
        ],
    },
    {
        name: languageArtsSubjectInfo.subjectName,
        sortOrder: 2,
        subjectBid: languageArtsSubjectInfo.subjectBid,
        courses: [
            __assign({ name: "Reading", sortOrder: 9, fullDisplayName: "Language Arts: Reading", measurementScaleID: "2", apiKey: "reading" }, languageArtsSubjectInfo),
            __assign({ name: "Reading (Spanish)", sortOrder: 10, fullDisplayName: "Language Arts: Reading (Spanish)", measurementScaleID: "7", apiKey: "reading-spanish" }, languageArtsSubjectInfo),
            __assign({ name: "Language Usage", sortOrder: 11, fullDisplayName: "Language Arts: Language Usage", measurementScaleID: "3", apiKey: "language-usage" }, languageArtsSubjectInfo),
        ],
    },
    {
        name: scienceSubjectInfo.subjectName,
        sortOrder: 3,
        subjectBid: scienceSubjectInfo.subjectBid,
        courses: [
            __assign({ name: "Science K-12", sortOrder: 12, fullDisplayName: "Science: Science K-12", measurementScaleID: "4", apiKey: "science-general-science" }, scienceSubjectInfo),
            __assign({ name: "Earth and Space Sciences", sortOrder: 13, fullDisplayName: "Science: Earth and Space Sciences", measurementScaleID: "107", apiKey: "earth-and-space-sciences" }, scienceSubjectInfo),
            __assign({ name: "Earth, Space, and Life Sciences", sortOrder: 14, fullDisplayName: "Science: Earth, Space, and Life Sciences", measurementScaleID: "110", apiKey: "earth-space-and-life-sciences" }, scienceSubjectInfo),
            __assign({ name: "Life Sciences", sortOrder: 15, fullDisplayName: "Science: Life Sciences", measurementScaleID: "108", apiKey: "life-sciences" }, scienceSubjectInfo),
            __assign({ name: "Physical Sciences", sortOrder: 16, fullDisplayName: "Physical Sciences", measurementScaleID: "109", apiKey: "physical-sciences" }, scienceSubjectInfo),
        ],
    },
];
//# sourceMappingURL=subjects.js.map